import { WasteClassification } from "encamp-prisma/generated/browser";

/** A manifest row's Classification column as the enum ingestion stamps; null when it names none. */
export function mapWasteClassification(
  classification: string | null | undefined
): WasteClassification | null {
  if (!classification) return null;
  switch (classification.trim().toUpperCase()) {
    case "NONHAZARDOUS":
      return WasteClassification.NONHAZARDOUS;
    case "RCRA_HAZARDOUS":
      return WasteClassification.RCRA_HAZARDOUS;
    case "RCRA_ACUTELY_HAZARDOUS":
      return WasteClassification.RCRA_ACUTELY_HAZARDOUS;
    case "STATE_REGULATED":
      return WasteClassification.STATE_REGULATED;
    default:
      return null;
  }
}

/** A manifest row's Reportable column as the `willNotReport` ingestion stamps; null when it is neither value. */
export function mapVendorWillNotReport(reportable: string | null | undefined): boolean | null {
  if (reportable === "Reportable") return false;
  if (reportable === "Not Reportable") return true;
  return null;
}
